import {
  AppLoginMethods,
  LOCIZE_LOGIN_TRANSLATION_KEYS,
  LocizeNamespaces,
  PageAttributeNames,
} from 'app-constants';
import { DisclaimerNotification } from 'components/notification';
import PinConfirmationComponent from 'components/pin-confirmation/PinConfirmation';
import type { VisiblePageAttributes } from 'models';
import { useTranslation } from 'react-i18next';

interface PinConfirmationViewProps {
  smartIdChallengeId: string;
  mobileIdChallengeId: string;
  stopLoginPolling: () => void;
  selectedLoginMethod: AppLoginMethods;
  visiblePageAttributes: VisiblePageAttributes;
}

export const PinConfirmationView = ({
  smartIdChallengeId,
  mobileIdChallengeId,
  stopLoginPolling,
  selectedLoginMethod,
  visiblePageAttributes,
}: PinConfirmationViewProps) => {
  const { t } = useTranslation(LocizeNamespaces.login);

  return (
    <>
      <PinConfirmationComponent
        onCancel={stopLoginPolling}
        pin={smartIdChallengeId || mobileIdChallengeId}
      />

      {visiblePageAttributes[PageAttributeNames.smartIdFullDisclaimer] &&
        selectedLoginMethod === AppLoginMethods.smartId && (
          <DisclaimerNotification className="mt-6">
            {t(LOCIZE_LOGIN_TRANSLATION_KEYS.smartIdFullVersionDisclaimer)}
          </DisclaimerNotification>
        )}
    </>
  );
};
